import WebHeaderSFC from "./WebHeader.vue";
export const WebHeader = WebHeaderSFC;
